(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.layered-slideshow__container').forEach(container => {
    const btn = container.querySelector('.slideshow-arrow--next');
    const dots = container.querySelectorAll('.slideshow-dot');
    const rightStart = 200;
    const rightEnd = 32;

    function updateUI() {
      const tabs = container.querySelectorAll('[role="tab"]');
      const active = container.querySelector('[role="tab"][aria-selected="true"]');
      const idx = Array.from(tabs).indexOf(active);
      const total = tabs.length - 1;

      // Actualizar flecha
      if (btn) {
        const right = total === 0 ? rightStart : rightStart - ((rightStart - rightEnd) / total * idx);
        btn.style.right = Math.round(right) + 'px';
      }

      // Actualizar puntos
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === idx);
      });
    }

    // Flecha siguiente
    if (btn) {
      btn.addEventListener('click', () => {
        const tabs = container.querySelectorAll('[role="tab"]');
        const active = container.querySelector('[role="tab"][aria-selected="true"]');
        const idx = Array.from(tabs).indexOf(active);
        const next = tabs[(idx + 1) % tabs.length];
        if (next) { next.click(); setTimeout(updateUI, 300); }
      });
    }

    // Puntos
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const tabs = container.querySelectorAll('[role="tab"]');
        if (tabs[i]) { tabs[i].click(); setTimeout(updateUI, 300); }
      });
    });

    // Tabs directas
    container.querySelectorAll('[role="tab"]').forEach(tab => {
      tab.addEventListener('click', () => setTimeout(updateUI, 300));
    });

    updateUI();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
